<template>
  <div>
    <div class="indexPage">
      <a name="page1"></a>
      <div class="page page1">
        <div class="page1-inner">
          <div class="navWrap" :class="scrollTop > 100 ? 'activeNav' : ''">
            <div class="headerNav">
              <!-- <img class="headerLogo" src="../assets/images/header-logo.png" /> -->
              <img
                class=""
                src="../assets/images/zdy-logo/white-transp.svg"
                alt="SVG Image"
                width="120"
              />
              <ul class="nav-ul">
                <li
                  class="itemLi"
                  :class="activeIndex == '0' ? 'active' : ''"
                  @click="navClick('1')"
                >
                  <a href="#page1">首页</a>
                </li>
                <li
                  class="itemLi"
                  :class="activeIndex == '1' ? 'active' : ''"
                  @click="navClick('2')"
                >
                  <a href="#page2">生态平台</a>
                </li>
                <li
                  class="itemLi"
                  :class="activeIndex == '2' ? 'active' : ''"
                  @click="navClick('3')"
                >
                  <a href="#page3">产品中心</a>
                </li>
                <li
                  class="itemLi"
                  :class="activeIndex == '3' ? 'active' : ''"
                  @click="navClick('4')"
                >
                  <a href="#page6">公司介绍</a>
                </li>
                <li
                  class="itemLi"
                  :class="activeIndex == '4' ? 'active' : ''"
                  @click="navClick('5')"
                >
                  <a href="#page7">在线留言</a>
                </li>
                <li class="itemLi">
                  <router-link target="_blank" :to="{ path: '/app' }"
                    >逛当铺</router-link
                  >
                </li>
                <li class="itemLi">
                  <router-link target="_blank" :to="{ path: '/dianyun' }"
                    >中典云</router-link
                  >
                </li>
              </ul>
              <div class="headerTel">
                <i class="tel-icon"></i>
                <li class="itemLi"><a href="#page8">400-8655-615</a></li>
              </div>
            </div>
          </div>
          <el-carousel
            :interval="5000"
            arrow="never"
            @change="carouselChange"
            :autoplay="false"
          >
            <el-carousel-item>
              <!-- <video id="bannerVideo1" ref="bannerVideo1" class="video" autoplay muted @ended="onPlayerEnded1"
                src="../assets/images/banner01-video.mp4" poster="../assets/images/banner01-video-pre.png"></video> -->

              <!-- <video id="bannerVideo1" ref="bannerVideo1" class="video" autoplay muted
                poster="../assets/images/banner01-video-pre.png"></video> -->
              <video
                id="bannerVideo1"
                ref="bannerVideo1"
                class="video"
                autoplay
                muted
                poster="https://pic.imgdb.cn/item/63f70a66f144a010071ef59e.png"
              ></video>
              <div class="banner1-content">
                <div class="banner1-inner">
                  <img class="line1" src="../assets/images/page1-line1.png" />
                  <div class="line2">中典云，典当行业数字化生态平台</div>
                  <div class="line3">
                    加入DDCloudPlus，开启典当行业数字化时代
                  </div>
                  <img class="imgPC" src="../assets/images/page1-PC.png" />
                  <div class="ljty">立即体验</div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <!-- <video id="bannerVideo2" ref="bannerVideo2" class="video" autoplay muted @ended="onPlayerEnded2"
                src="../assets/images/banner02-video.mp4" poster="../assets/images/banner02-video-pre.png"></video> -->
              <!-- <video id="bannerVideo2" ref="bannerVideo2" class="video" autoplay muted
                poster="../assets/images/banner02-video-pre.png"></video> -->
              <video
                id="bannerVideo2"
                ref="bannerVideo2"
                class="video"
                autoplay
                muted
                poster="https://pic.imgdb.cn/item/63f70806f144a0100718f8fc.png"
              ></video>
              <div class="banner2-content">
                <div class="banner2-inner">
                  <img
                    class="banner2-logo"
                    src="../assets/images/banner2-logo.png"
                  />
                  <div class="banner2-line"></div>
                  <div class="banner2-text-wrap">
                    <div class="banner2-text">
                      我们致力于通过互联网、大数据、云计算、人工智能、区块链等金融科技的应用，
                    </div>
                    <div class="banner2-text">
                      打造典当行业生态合作伙伴平台，让每一个生态伙伴感受到科技带来的便捷，助力典当行业创新
                    </div>
                    <div class="banner2-text">
                      发展，为个人和中小企业提供更有温度的普惠金融服务。
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <img
            class="pageDownarrow"
            src="../assets/images/page1-downarrow.png"
          />
        </div>
        <div class="page1-mobile">
          <div class="mobile1-inner">
            <!-- <video id="videoPlay" class="videoMobile" loop="loop" autoplay muted playsinline="true" preload="auto"
              ref="bannerVideo3" poster="../assets/images/banner-video_mobile-pre.png">
              <source src="../assets/images/banner-video_mobile.mp4" type="video/mp4"> -->
            <video
              id="videoPlay"
              class="videoMobile"
              loop="loop"
              playsinline="true"
              preload="auto"
              ref="bannerVideo3"
              poster="../assets/images/banner-video_mobile-pre.png"
            ></video>
            <div class="videoContent">
              <div class="videoContentInner">
                <div class="linkTel">
                  <!-- <img
                    class="headerLogoMobile"
                    src="../assets/images/header-logo_mobile.png"
                  /> -->
                  <img
                    class=""
                    src="../assets/images/zdy-logo/white-transp.svg"
                    alt="SVG Image"
                    width="80"
                  />
                  <div data-v-483a46c0="" class="headerTel">
                    <i data-v-483a46c0="" class="tel-icon"></i>
                    <li data-v-483a46c0="" class="itemLi">
                      <a data-v-483a46c0="" href="tel:400-8655-615"
                        >400-8655-615</a
                      >
                    </li>
                  </div>
                </div>
                <img
                  class="line1"
                  src="../assets/images/page1-line1_mobile.png"
                />
                <div class="line2">中典云，</div>
                <div class="line2">典当行业数字化生态平台</div>
                <div class="line3">加入DDCloudPlus，开启典当行业数字化时代</div>
                <div class="slid">
                  <span class="sliding">SLIDING</span>
                  <span class="openLine"></span>
                </div>
              </div>
            </div>
          </div>
          <img
            class="pageDownarrow"
            src="../assets/images/page1-downarrow_mobile.png"
          />
        </div>
      </div>
      <a name="page2"></a>
      <div class="page page2">
        <div class="page2-inner" :class="isAnimation2 ? 'fadeInUp' : ''">
          <div class="line1">中典云，典当行业数字化生态平台</div>
          <div class="line2">中典云，典当行业数字化生态平台</div>
          <div class="center">
            <div class="ddybox">
              <!-- <img class="ddy" src="../assets/images/page2-ddy.png"> -->
              <img
                class="ddy"
                src="https://pic.imgdb.cn/item/63f70c05f144a010072279dc.png"
              />
              <!-- <img class="ddyLogo" src="../assets/images/page2-ddy-logo.png" /> -->
              <img
                class="ddyLogo"
                src="../assets/images/zdy-logo/white-transp.svg"
                alt="SVG Image"
                width="140"
              />
            </div>
            <div class="ddypls outerbox">
              <img class="ddh" src="../assets/images/page2-ddh.png" />
              <div
                class="mouseBox"
                @mouseover="ddyMouseover"
                @mouseout="ddyMouseout"
              >
                <div class="commonboxShow ddyAbso" v-show="!ddyShow">
                  <span class="title">中典云</span>
                </div>
                <div class="commonboxHide ddyAbso" v-show="ddyShow">
                  <span class="title">中典云</span>
                  <span class="text">
                    典当核心业务系统<br />
                    财务系统<br />
                    人力资源系统<br />
                    办公系统
                  </span>
                </div>
              </div>
            </div>
            <div class="zxpt">
              <img class="hyxh" src="../assets/images/page2-hyxh.png" />
              <div
                class="mouseBox"
                @mouseover="zxptMouseover"
                @mouseout="zxptMouseout"
              >
                <div class="commonboxShow zxptAbso" v-show="!zxptShow">
                  <span class="title">在线平台</span>
                </div>
                <div class="commonboxHide zxptAbso" v-show="zxptShow">
                  <span class="title">在线平台</span>
                  <span class="text">
                    C端用户商城<br />
                    B端典当合作
                  </span>
                </div>
              </div>
            </div>
            <div class="jgjkpt">
              <img class="jgbm" src="../assets/images/page2-jgbm.png" />
              <div
                class="mouseBox"
                @mouseover="jgptMouseover"
                @mouseout="jgptMouseout"
              >
                <div class="commonboxShow jgptAbso" v-show="!jgptShow">
                  <span class="title">监管接口平台</span>
                </div>
                <div class="commonboxHide jgptAbso" v-show="jgptShow">
                  <span class="title">监管接口平台</span>
                  <span class="text">
                    全国典当监管<br />
                    地方金监管<br />
                    电子当票
                  </span>
                </div>
              </div>
            </div>
            <div class="sthzhb">
              <img class="pgjg" src="../assets/images/page2-pgjg.png" />
              <div
                class="mouseBox"
                @mouseover="stptMouseover"
                @mouseout="stptMouseout"
              >
                <div class="commonboxShow stptAbso" v-show="!stptShow">
                  <span class="title">生态合作伙伴</span>
                </div>
                <div class="commonboxHide stptAbso" v-show="stptShow">
                  <span class="title">生态合作伙伴</span>
                  <span class="text">
                    房产评估<br />
                    民品评估<br />
                    大数据征信<br />
                    大数据风控<br />
                    资产清收
                  </span>
                </div>
              </div>
            </div>
            <img class="jrkj" src="../assets/images/page2-jrkj.png" />
            <div class="bottomPlate">
              <li class="plateLi">
                <span>互联网</span>
              </li>
              <li class="plateLi">
                <span>大数据</span>
              </li>
              <li class="plateLi">
                <span>云计算</span>
              </li>
              <li class="plateLi">
                <span>人工智能</span>
              </li>
              <li class="plateLi">
                <span>区块链</span>
              </li>
            </div>
          </div>
        </div>
        <div class="page2-mobile">
          <div class="mobile2-inner">
            <div class="line1">中典云，典当行业数字化生态平台</div>
            <div class="line2">加入DDCloudPlus，开启典当行业数字化时代</div>
            <div class="main">
              <div class="swipWrap" id="container">
                <div class="inner swipItem a">
                  <div class="itemwrap">
                    <div class="itemTop"></div>
                    <div class="itemContent">
                      <div>典当核心业务系统</div>
                      <div>财务系统</div>
                      <div>人力资源系统</div>
                      <div>办公系统</div>
                    </div>
                  </div>
                </div>
                <div class="inner swipItem b">
                  <div class="itemwrap">
                    <div class="itemTop"></div>
                    <div class="itemContent">
                      <div>房产评估</div>
                      <div>民品评估</div>
                      <div>大数据征信</div>
                      <div>大数据风控</div>
                      <div>资产清收</div>
                    </div>
                  </div>
                </div>
                <div class="inner swipItem c">
                  <div class="itemwrap">
                    <div class="itemTop"></div>
                    <div class="itemContent">
                      <div>全国典当监管</div>
                      <div>地方金监管</div>
                      <div>电子当票</div>
                    </div>
                  </div>
                </div>
                <div class="inner swipItem d">
                  <div class="itemwrap">
                    <div class="itemTop"></div>
                    <div class="itemContent">
                      <div>C端用户商城</div>
                      <div>B端典当合作</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ddybox">
              <img class="ddy" src="../assets/images/page2-ddy_mobile.png" />
              <!-- <img
                class="ddyLogo"
                src="../assets/images/page2-ddy-logo_mobile.png"
              /> -->
              <img
                class="ddyLogo"
                src="../assets/images/zdy-logo/white-transp.svg"
                alt="SVG Image"
              />
              <img class="jrkj" src="../assets/images/page2-jrkj_mobile.png" />
              <div class="bottomPlate">
                <li class="plateLi">
                  <span>互联网</span>
                </li>
                <li class="plateLi">
                  <span>大数据</span>
                </li>
                <li class="plateLi">
                  <span>云计算</span>
                </li>
                <li class="plateLi">
                  <span>人工智能</span>
                </li>
                <li class="plateLi">
                  <span>区块链</span>
                </li>
              </div>
              <div class="bar ddybar"><span class="bar1">中典云</span></div>
              <div class="bar ddypls"><span class="bar2">中典云</span></div>
              <div class="bar zxpt"><span class="bar3">在线平台</span></div>
              <div class="bar jgpt"><span class="bar4">监管接口平台</span></div>
              <div class="bar stpt"><span class="bar5">生态合作伙伴</span></div>
            </div>
          </div>
        </div>
      </div>
      <a name="page3"></a>
      <div class="page page3">
        <div class="page3-bg"></div>
        <div class="page3-inner" :class="isAnimation3 ? 'fadeInUp' : ''">
          <div class="inner-up">
            <img class="page3-ddlogo" src="../assets/images/page3-ddlogo.png" />
            <h3 class="page3-title">典当行管理系统升级版SaaS产品模块</h3>
            <h6 class="page3-subtitle">中典云，典当行业数字化生态平台</h6>
            <div class="page3-btn-pc">PC端</div>
          </div>
          <div class="inner-middle">
            <li
              class="liItem"
              :class="liItemActive == '7' ? 'liItemActive' : ''"
              @click="liItemClick('7')"
            >
              <i class="icon iconfont icon-page3-pgcx"></i>
              <span class="icon-text">数据驾驶舱</span>
            </li>
            <li
              class="liItem"
              :class="liItemActive == '1' ? 'liItemActive' : ''"
              @click="liItemClick('1')"
            >
              <i class="icon iconfont icon-page3-ywdt"></i>
              <span class="icon-text">业务大厅</span>
            </li>
            <li
              class="liItem"
              :class="liItemActive == '2' ? 'liItemActive' : ''"
              @click="liItemClick('2')"
            >
              <i class="icon iconfont icon-page3-fkgl"></i>
              <span class="icon-text">风控管理</span>
            </li>
            <li
              class="liItem"
              :class="liItemActive == '3' ? 'liItemActive' : ''"
              @click="liItemClick('3')"
            >
              <i class="icon iconfont icon-page3-zdgl"></i>
              <span class="icon-text">在当管理</span>
            </li>
            <li
              class="liItem"
              :class="liItemActive == '4' ? 'liItemActive' : ''"
              @click="liItemClick('4')"
            >
              <i class="icon iconfont icon-page3-cwgl"></i>
              <span class="icon-text">财务管理</span>
            </li>
            <li
              class="liItem"
              :class="liItemActive == '5' ? 'liItemActive' : ''"
              @click="liItemClick('5')"
            >
              <i class="icon iconfont icon-page3-khgl"></i>
              <span class="icon-text">客户管理</span>
            </li>
            <li
              class="liItem"
              :class="liItemActive == '6' ? 'liItemActive' : ''"
              @click="liItemClick('6')"
            >
              <i class="icon iconfont icon-page3-jgdj"></i>
              <span class="icon-text">监管对接</span>
            </li>
          </div>
          <div class="inner-bottom">
            <div
              class="bottom-item"
              :class="itemIndex == '1' ? 'itemShow' : 'itemHidden'"
            >
              <div class="bottom-right">
                <div class="right-line1">业务大厅</div>
                <div class="right-line2">The business hall</div>
                <div class="right-line3">
                  实现典当业务的全流程一站式在线办理，包括收当管理、续当管理、赎当管理、绝当管理、当票打印、合同管理等。
                </div>
                <span class="right-btn">立即体验</span>
              </div>
              <div class="bottom-left">
                <!-- <img class="page3-img" src="../assets/images/page3-img-ywdt.png"> -->
                <img
                  class="page3-img"
                  src="https://pic.imgdb.cn/item/63f70c11f144a01007228cb7.png"
                />
              </div>
            </div>
            <div
              class="bottom-item"
              :class="itemIndex == '2' ? 'itemShow' : 'itemHidden'"
            >
              <div class="bottom-right">
                <div class="right-line1">风险管理</div>
                <div class="right-line2">Risk management</div>
                <div class="right-line3">
                  全流程的数字化风险闭环管理，利用大数据风控、AI人工智能风控算法等科技手段，结合多级风险控制模型，实现收当风险管理、续当风险管理、赎当风险管理、绝当风险管理全生命周期的风险控制。
                </div>
                <span class="right-btn">立即体验</span>
              </div>
              <div class="bottom-left">
                <!-- <img class="page3-img" src="../assets/images/page3-img-fxgk.png"> -->
                <img
                  class="page3-img"
                  src="https://pic.imgdb.cn/item/63f70c05f144a01007227a6a.png"
                />
              </div>
            </div>
            <div
              class="bottom-item"
              :class="itemIndex == '3' ? 'itemShow' : 'itemHidden'"
            >
              <div class="bottom-right">
                <div class="right-line1">在当管理</div>
                <div class="right-line2">Management after loan</div>
                <div class="right-line3">
                  对在当项目进行实时智能化风险跟踪，进行项目风险预警、到期提醒、逾期管理、绝当处置，平台利用风控模型引擎自动识别项目风险，实现智能风险评级。
                </div>
                <span class="right-btn">立即体验</span>
              </div>
              <div class="bottom-left">
                <!-- <img class="page3-img" src="../assets/images/page3-img-dhgl.png"> -->
                <img
                  class="page3-img"
                  src="https://pic.imgdb.cn/item/63f70c05f144a01007227a42.png"
                />
              </div>
            </div>
            <div
              class="bottom-item"
              :class="itemIndex == '4' ? 'itemShow' : 'itemHidden'"
            >
              <div class="bottom-right">
                <div class="right-line1">财务管理</div>
                <div class="right-line2">Financial management</div>
                <div class="right-line3">
                  NC财务数据推送包含：当票综合费、利息、本金、余额等信息；监管报送：月度向监管平台报送统计数据，资产负债、利润、经营情况数据。
                </div>
                <span class="right-btn">立即体验</span>
              </div>
              <div class="bottom-left">
                <!-- <img class="page3-img" src="../assets/images/page3-img-cwgl.png"> -->
                <img
                  class="page3-img"
                  src="https://pic.imgdb.cn/item/63f70c05f144a01007227a12.png"
                />
              </div>
            </div>
            <div
              class="bottom-item"
              :class="itemIndex == '5' ? 'itemShow' : 'itemHidden'"
            >
              <div class="bottom-right">
                <div class="right-line1">客户管理</div>
                <div class="right-line2">Customer management</div>
                <div class="right-line3">
                  以客户中心，全流程的客户跟踪转化管理，包括客户查询、潜客管理、客户画像、客户交易分析，客户消息提醒，到期提醒、还款提醒、逾期提醒等。
                </div>
                <span class="right-btn">立即体验</span>
              </div>
              <div class="bottom-left">
                <!-- <img class="page3-img" src="../assets/images/page3-img-khgl.png"> -->
                <img
                  class="page3-img"
                  src="https://pic.imgdb.cn/item/63f70c11f144a01007228c2e.png"
                />
              </div>
            </div>
            <div
              class="bottom-item"
              :class="itemIndex == '6' ? 'itemShow' : 'itemHidden'"
            >
              <div class="bottom-right">
                <div class="right-line1">监管对接</div>
                <div class="right-line2">Regulatory docking</div>
                <div class="right-line3">
                  与全国典当监管系统实现对接，可进行当票的领取、打印、业务信息上报及财务资产负债、利润表、经营情况统计类数据的报送，满足银保监会及各地方金融局的监管要求。
                </div>
                <span class="right-btn">立即体验</span>
              </div>
              <div class="bottom-left">
                <!-- <img class="page3-img" src="../assets/images/page3-img-pgcx.png"> -->
                <img
                  class="page3-img"
                  src="https://pic.imgdb.cn/item/63f70c11f144a01007228c4b.png"
                />
              </div>
            </div>
            <div
              class="bottom-item"
              :class="itemIndex == '7' ? 'itemShow' : 'itemHidden'"
            >
              <div class="bottom-right">
                <div class="right-line1">数据驾驶舱</div>
                <div class="right-line2">Data screen</div>
                <div class="right-line3">
                  实时全面的监控公司的日常经营情况、经营数据分析、收入分析、成本分析、客户分析、收款预测等，以及当日、月度、季度、年度的营收数据对比分析与走势分析。
                </div>
                <span class="right-btn">立即体验</span>
              </div>
              <div class="bottom-left">
                <!-- <img class="page3-img" src="../assets/images/page3-img-sjjsc.png"> -->
                <img
                  class="page3-img"
                  src="https://pic.imgdb.cn/item/63f70c11f144a01007228c5a.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="page3-bg-mobile"></div>
        <div class="page3-mobile">
          <div class="mobile3-inner">
            <div class="inner-up">
              <h3 class="page3-title">典当行管理系统升级版SaaS产品模块</h3>
              <h6 class="page3-subtitle">中典云，典当行业数字化生态平台</h6>
            </div>
            <div class="inner-bottom">
              <Tabs v-model="tabActive" swipeable>
                <Tab title="数据驾驶舱" name="7">
                  <div class="tabContent">
                    <!-- <img class="page3-img-mobile" src="../assets/images/page3-img-sjjsc_mobile.png"> -->
                    <img
                      class="page3-img-mobile"
                      src="https://pic.imgdb.cn/item/63f70c11f144a01007228c83.png"
                    />
                    <div class="content">
                      <div class="right-line1">数据驾驶舱</div>
                      <div class="right-line2">Data screen</div>
                      <div class="right-line3">
                        实时全面的监控公司的日常经营情况、经营数据分析、收入分析、成本分析、客户分析、收款预测等，以及当日、月度、季度、年度的营收数据对比分析与走势分析。
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab title="业务大厅" name="1">
                  <div class="tabContent">
                    <img
                      class="page3-img-mobile"
                      src="../assets/images/page3-img-ywdt_mobile.png"
                    />
                    <div class="content">
                      <div class="right-line1">业务大厅</div>
                      <div class="right-line2">The business hall</div>
                      <div class="right-line3">
                        实现典当业务的全流程一站式在线办理，包括收当管理、续当管理、赎当管理、绝当管理、当票打印、合同管理等。
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab title="风险管理" name="2">
                  <div class="tabContent">
                    <img
                      class="page3-img-mobile"
                      src="../assets/images/page3-img-fxgl_mobile.png"
                    />
                    <div class="content">
                      <div class="right-line1">风险管理</div>
                      <div class="right-line2">Risk management</div>
                      <div class="right-line3">
                        全流程的数字化风险闭环管理，利用大数据风控、AI人工智能风控算法等科技手
                        段，结合多级风险控制模型，实现收当风险管理、续当风险管理、赎当风险管理、
                        绝当风险管理全生命周期的风险控制。
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab title="在当管理" name="3">
                  <div class="tabContent">
                    <img
                      class="page3-img-mobile"
                      src="../assets/images/page3-img-zdgl_mobile.png"
                    />
                    <div class="content">
                      <div class="right-line1">在当管理</div>
                      <div class="right-line2">Management after loan</div>
                      <div class="right-line3">
                        对在当项目进行实时智能化风险跟踪，进行项目风险预警、到期提醒、逾期管理、绝当处置，平台利用风控模型引擎自动识别项目风险，实现智能风险评级。
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab title="财务管理" name="4">
                  <div class="tabContent">
                    <img
                      class="page3-img-mobile"
                      src="../assets/images/page3-img-cwgl_mobile.png"
                    />
                    <div class="content">
                      <div class="right-line1">财务管理</div>
                      <div class="right-line2">Financial management</div>
                      <div class="right-line3">
                        NC财务数据推送包含：当票综合费、利息、本金、余额等信息；
                        监管报送：月度向监管平台报送统计数据，资产负债、利润、经营情况数据。
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab title="客户管理" name="5">
                  <div class="tabContent">
                    <img
                      class="page3-img-mobile"
                      src="../assets/images/page3-img-khgl_mobile.png"
                    />
                    <div class="content">
                      <div class="right-line1">客户管理</div>
                      <div class="right-line2">Customer management</div>
                      <div class="right-line3">
                        以客户中心，全流程的客户跟踪转化管理，包括客户查询、潜客管理、客户画像、
                        客户交易分析，客户消息提醒，到期提醒、还款提醒、逾期提醒等。
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab title="监管对接" name="6">
                  <div class="tabContent">
                    <img
                      class="page3-img-mobile"
                      src="../assets/images/page3-img-jgdj_mobile.png"
                    />
                    <div class="content">
                      <div class="right-line1">监管对接</div>
                      <div class="right-line2">Regulatory docking</div>
                      <div class="right-line3">
                        与全国典当监管系统实现对接，可进行当票的领取、打印、业务信息上报及财务资
                        产负债、利润表、经营情况统计类数据的报送，满足银保监会及各地方金融局的监
                        管要求。
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <!-- <a name="page4"></a>
    <div class="page4">
      <div class="page4-bg"></div>
      <div class="page4-inner">
        <div class="inner-up">
          <h3 class="page4-title">典当行移动智能产品模块</h3>
          <h6 class="page4-subtitle">典当云+，典当行业数字化生态平台</h6>
          <div class="page4-btn-mobile">移动端</div>
        </div>
        <div class="inner-bottom">
          <div class="bottom-card">
            <div class="card-innner">
              <div class="card-title">
                <i class="icon iconfont icon-page4-xcxkhd"></i>
                <span class="title-text">小程序经理端</span>
              </div>
              <div class="card-content">
                <li class="liItem"><i class="dot"></i>风险评估手机报单</li>
                <li class="liItem"><i class="dot"></i>风控管理移动审批</li>
                <li class="liItem"><i class="dot"></i>在线抢单移动典当</li>
                <li class="liItem"><i class="dot"></i>移动收款手机办理</li>
                <li class="liItem"><i class="dot"></i>客户管理贷后服务</li>
                <li class="liItem"><i class="dot"></i>业务查询统计分析</li>
              </div>
            </div>
          </div>
          <div class="bottom-card">
            <div class="card-innner">
              <div class="card-title">
                <i class="icon iconfont icon-page4-xcxkhd"></i>
                <span class="title-text">小程序客户端</span>
              </div>
              <div class="card-content">
                <li class="liItem"><i class="dot"></i>典当业务在线申请</li>
                <li class="liItem"><i class="dot"></i>还款计划一键查看</li>
                <li class="liItem"><i class="dot"></i>在线业务自助缴费</li>
                <li class="liItem"><i class="dot"></i>业务消息实时推送</li>
                <li class="liItem"><i class="dot"></i>查看业务办理进度</li>
                <li class="liItem"><i class="dot"></i>查看个人业务信息</li>
              </div>
            </div>
          </div>
          <div class="bottom-card">
            <div class="card-innner">
              <div class="card-title">
                <i class="icon iconfont icon-page4-wxgzh"></i>
                <span class="title-text">微信公众号</span>
              </div>
              <div class="card-content">
                <li class="liItem"><i class="dot"></i>典当业务在线申请</li>
                <li class="liItem"><i class="dot"></i>还款计划一键查看</li>
                <li class="liItem"><i class="dot"></i>在线业务自助缴费</li>
                <li class="liItem"><i class="dot"></i>业务消息实时推送</li>
                <li class="liItem"><i class="dot"></i>查看业务办理进度</li>
                <li class="liItem"><i class="dot"></i>查看个人业务信息</li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a name="page5"></a>
    <div class="page5">
      <div class="page5-inner">
        <div class="page5-title">典当业务全生命周期管理闭环</div>
        <div class="page5-subtitle">典当云+，典当行业数字化生态平台</div>
        <img class="page5-img" src="../assets/images/page5-img.png">
      </div>
    </div> -->
      <a name="page6"></a>
      <div class="page page6">
        <div class="page6-bg"></div>
        <div class="page6-inner" :class="isAnimation4 ? 'fadeInUp' : ''">
          <div class="page6-title">我们, 就在您的身边</div>
          <div class="page6-subtitle">中典云，典当行业数字化生态平台</div>
          <div class="page6-item">
            <li class="itemLi">
              <img class="itemImg" src="../assets/images/page6-item-zgqy.png" />
              <div class="itemRight">
                <div class="rightTitle">整个企业</div>
                <div class="rightContent">
                  降低行政运营成本，提升行政运<br />转效率
                </div>
              </div>
            </li>
            <li class="itemLi">
              <img class="itemImg" src="../assets/images/page6-item-ddgl.png" />
              <div class="itemRight">
                <div class="rightTitle">典当管理</div>
                <div class="rightContent">
                  数据驱动业务优化，量化行政价<br />值，提高客户满意度
                </div>
              </div>
            </li>
            <li class="itemLi">
              <img class="itemImg" src="../assets/images/page6-item-xzry.png" />
              <div class="itemRight">
                <div class="rightTitle">行政人员</div>
                <div class="rightContent">
                  业务场景全覆盖，数据多维度采集<br />分析降低重复工作
                </div>
              </div>
            </li>
          </div>
          <div class="page6-content">
            <p>
              我们致力于通过互联网、大数据、云计算、人工智能、区块链等金融科技的应用，打造典当行业生态合作伙伴平台，让每一个生态伙伴感受到科技带来的便捷，助力典当
            </p>
            <p>行业创新发展，为个人和中小企业提供更有温度的普惠金融服务。</p>
          </div>
          <div class="page6-panel">
            <li class="itemLi">
              <img class="itemImg" src="../assets/images/page6-item-ppdw.png" />
              <div class="imgTitle">品牌定位</div>
              <div class="itemTitle">典当智能化管家</div>
            </li>
            <li class="itemLi">
              <img class="itemImg" src="../assets/images/page6-item-ppsm.png" />
              <div class="imgTitle">品牌使命</div>
              <div class="itemTitle">AI赋能，让典当管理更简单</div>
            </li>
            <li class="itemLi">
              <img class="itemImg" src="../assets/images/page6-item-ppyj.png" />
              <div class="imgTitle">品牌愿景</div>
              <div class="itemTitle">智能典当管理全球化</div>
            </li>
          </div>
        </div>
        <div class="page6-mobile-wrap">
          <div class="page6-bg-mobile"></div>
          <div class="page6-mobile">
            <div class="mobile6-inner">
              <div class="page6-title">我们, 就在您的身边</div>
              <div class="page6-subtitle">中典云，典当行业数字化生态平台</div>
              <div class="page6-item">
                <li class="itemLi libg1">
                  <div class="imgBox">
                    <img
                      class="itemImg"
                      src="../assets/images/page6-item-zgqy_mobile.png"
                    />
                  </div>
                  <div class="itemRight bl">
                    <div class="rightTitle">整个企业</div>
                    <div class="rightContent">
                      降低行政运营成本，提升行政运转效率
                    </div>
                  </div>
                </li>
                <li class="itemLi libg2">
                  <div class="itemRight br">
                    <div class="rightTitle">典当管理</div>
                    <div class="rightContent">
                      数据驱动业务优化，量化行政价<br />值，提高客户满意度
                    </div>
                  </div>
                  <div class="imgBox">
                    <img
                      class="itemImg"
                      src="../assets/images/page6-item-ddgl_mobile.png"
                    />
                  </div>
                </li>
                <li class="itemLi libg1">
                  <div class="imgBox">
                    <img
                      class="itemImg"
                      src="../assets/images/page6-item-xzry_mobile.png"
                    />
                  </div>
                  <div class="itemRight bl">
                    <div class="rightTitle">行政人员</div>
                    <div class="rightContent">
                      业务场景全覆盖，数据多维度采集<br />分析降低重复工作
                    </div>
                  </div>
                </li>
              </div>
            </div>
          </div>
          <div class="about">
            <div class="aboutUs">- ABOUT US -</div>
            <div class="page6-content">
              <p>我们致力于通过互联网、</p>
              <p>大数据、云计算、人工智能、区块链等金融科技的应用，</p>
              <p>打造典当行业生态合作伙伴平台，</p>
              <p>让每一个生态伙伴感受到科技带来的便捷，</p>
              <p>助力典当行业创新发展，</p>
              <p>为个人和中小企业提供更有温度的普惠金融服务。</p>
            </div>
            <div class="page6-panel">
              <li class="itemLi">
                <img
                  class="itemImg"
                  src="../assets/images/page6-item-ppdw_mobile.png"
                />
                <div class="imgTitle">品牌定位</div>
                <div class="itemTitle">典当智能化管家</div>
              </li>
              <li class="itemLi">
                <img
                  class="itemImg"
                  src="../assets/images/page6-item-ppsm.png"
                />
                <div class="imgTitle">品牌使命</div>
                <div class="itemTitle">AI赋能，让典当管理更简单</div>
              </li>
              <li class="itemLi">
                <img
                  class="itemImg"
                  src="../assets/images/page6-item-ppyj.png"
                />
                <div class="imgTitle">品牌愿景</div>
                <div class="itemTitle">智能典当管理全球化</div>
              </li>
            </div>
          </div>
        </div>
      </div>
      <a name="page7"></a>
      <div class="page page7">
        <div class="page7-inner" :class="isAnimation5 ? 'fadeInUp' : ''">
          <div class="page7-title">
            <div class="title">在线留言</div>
            <div class="subTitle">Online message</div>
          </div>
          <div class="page7-form">
            <el-form
              :model="messageForm"
              ref="messageForm"
              status-icon
              label-position="left"
              label-width="90px"
              style="font-size: 0"
            >
              <div class="formRow">
                <el-form-item
                  label="姓名:"
                  prop="customerName"
                  class="formItem mr32 pc"
                >
                  <el-input
                    size="mini"
                    maxlength="20"
                    v-model="messageForm.customerName"
                    placeholder="请输入您的姓名"
                    clearable
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="电话:"
                  prop="customerPhone"
                  class="formItem pc"
                >
                  <el-input
                    size="mini"
                    maxlength="15"
                    v-model="messageForm.customerPhone"
                    placeholder="请输入您的手机或者座机"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </div>
              <div class="formRow">
                <el-form-item
                  label="邮箱:"
                  prop="customerEmail"
                  class="formItem mr32 pc"
                >
                  <el-input
                    size="mini"
                    maxlength="30"
                    v-model="messageForm.customerEmail"
                    placeholder="请输入您的邮箱"
                    clearable
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="公司:"
                  prop="customerCompany"
                  class="formItem pc"
                >
                  <el-input
                    size="mini"
                    maxlength="30"
                    v-model="messageForm.customerCompany"
                    placeholder="请输入您的公司名称"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </div>
              <div class="formRow">
                <el-form-item
                  label="留言内容:"
                  prop="messageContent"
                  class="formItem1 pc"
                >
                  <el-input
                    size="mini"
                    type="textarea"
                    maxlength="1000"
                    v-model="messageForm.messageContent"
                    placeholder="请输入您的留言内容"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </div>
              <el-button
                class="messageBtn"
                :disabled="btnDisabled"
                @click="saveMessage"
                >提交留言</el-button
              >
            </el-form>
          </div>
        </div>
      </div>
      <div class="page7-mobile">
        <div class="mobile-inner">
          <div class="page7-title">
            <div class="messageTitle">
              <div class="title">在线留言</div>
              <div class="subTitle">Online message</div>
            </div>
            <div class="unfoldBtn" @click="unFold">{{ mesFoldBtnText }}</div>
          </div>
          <div class="page7-form" v-show="messageFormShow">
            <el-form
              :model="messageForm"
              ref="messageForm"
              status-icon
              label-position="left"
              style="font-size: 0"
            >
              <el-form-item
                label="姓名:"
                prop="customerName"
                class="formItem"
                label-width="80px"
              >
                <el-input
                  size="mini"
                  maxlength="10"
                  v-model="messageForm.customerName"
                  placeholder="请输入您的姓名"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="电话:"
                prop="customerPhone"
                class="formItem"
                label-width="80px"
              >
                <el-input
                  size="mini"
                  maxlength="11"
                  v-model="messageForm.customerPhone"
                  placeholder="请输入您的手机或者座机"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="邮箱:"
                prop="customerEmail"
                class="formItem"
                label-width="80px"
              >
                <el-input
                  size="mini"
                  maxlength="30"
                  v-model="messageForm.customerEmail"
                  placeholder="请输入您的邮箱"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="公司:"
                prop="customerCompany"
                class="formItem"
                label-width="80px"
              >
                <el-input
                  size="mini"
                  v-model="messageForm.customerCompany"
                  placeholder="请输入您的公司名称"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="留言内容:"
                prop="messageContent"
                class="formItem1"
                label-width="100px"
              >
                <el-input
                  size="mini"
                  type="textarea"
                  maxlength="1000"
                  v-model="messageForm.messageContent"
                  placeholder="请输入您的留言内容"
                >
                </el-input>
              </el-form-item>
              <el-button
                class="messageBtn"
                :disabled="btnDisabled"
                @click="saveMessage"
                >提交留言</el-button
              >
            </el-form>
          </div>
        </div>
      </div>
      <a name="page8"></a>
      <div class="page8">
        <div class="page8-outer">
          <div class="page8-inner">
            <div class="bottom-item" style="margin-bottom: 25px">
              <!-- <img class="bottom-logo" src="../assets/images/bottom-logo.png" /> -->
              <img
                class="bottom-logo"
                src="../assets/images/zdy-logo/white-transp.svg"
                alt="SVG Image"
                width="130"
              />
              <div class="logo-title">中典云，典当行业数字化生态平台</div>
            </div>
            <!-- <div class="bottom-item flex1" style="margin-bottom: 0px;">
              <div class="item">
                <span class="label">咨询热线：</span>
                <span class="value">010-6504-8009</span>
              </div>
            </div> -->
            <div style="display: flex">
              <div class="bottom-item flex" style="margin-right: 60px">
                <img
                  class="bottom-QRCode"
                  src="../assets/images/bottom-lxkf.png"
                  style="border-radius: 10px"
                />
                <div class="QRCode-title">联系客服</div>
              </div>
              <div class="bottom-item flex" style="margin-right: 60px">
                <img
                  class="bottom-QRCode"
                  src="../assets/images/bottom-FWCode.png"
                />
                <div class="QRCode-title">官方服务号</div>
              </div>
              <div class="bottom-item flex" style="margin-right: 60px">
                <img
                  class="bottom-QRCode"
                  src="../assets/images/bottom-QRCode.png"
                />
                <div class="QRCode-title">微信公众号</div>
              </div>
              <div class="bottom-item flex">
                <img
                  class="bottom-QRCode"
                  src="../assets/images/mobile-QRCode_gdpzh.png"
                />
                <div class="QRCode-title">逛当铺</div>
              </div>
            </div>
          </div>
          <div class="page8-bottom">
            <div class="page8-police">
              <!-- <p style="margin-right:5px;">©2005~2022 中程润达科技有限公司 京ICP备2022029321号 | </p> -->
              <p style="margin-right: 5px">
                ©2005~2022 中典云科（北京）科技有限公司
                <a
                  target="_blank"
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  style="
                    color: #fff;
                    cursor: pointer;
                    text-decoration: underline;
                  "
                  class="hrefHover"
                  >京ICP备2022029321号 |
                </a>
              </p>
              <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011202004047"
                style="
                  display: inline-block;
                  line-height: 20px;
                  cursor: pointer;
                "
              >
                <img
                  src="../assets/images/bottom-baImg.png"
                  style="float: left; margin-left: 5px"
                />
                <p
                  class="hrefHover"
                  style="
                    float: left;
                    height: 20px;
                    line-height: 20px;
                    margin: 0px 0px 0px 5px;
                    color: #ffffff;
                    text-decoration: underline;
                  "
                >
                  京公网安备 11011202004047号
                </p>
              </a>
            </div>
            <img
              class="backTop"
              @click="toTop"
              src="../assets/images/bottom-backTop.png"
            />
          </div>
        </div>
      </div>
      <div class="page8-mobile">
        <div class="page8-mobile-inner">
          <div class="bottom-item">
            <!-- <img
              class="bottom-logo"
              src="../assets/images/bottom-logo_mobile.png"
            /> -->
            <img
              class=""
              src="../assets/images/zdy-logo/white-transp.svg"
              alt="SVG Image"
              width="100"
            />
            <div class="logo-title">中典云，典当行业数字化生态平台</div>
          </div>
          <!-- <div class="bottom-link">
            <li class="linkLi">
              <div class="label"><i class="icon zxrx"></i>咨询热线：</div>
              <div class="value">010-6504-8009</div>
            </li>
          </div> -->
          <div class="bottom-linknet">
            <li class="netLi" @touchstart="showQRCode('qywx')">
              <img class="wx" src="../assets/images/bottom-link_qywx.png" />
              <span class="netText">联系客服</span>
            </li>
            <li class="netLi" @touchstart="showQRCode('wxgzh')">
              <img class="wx" src="../assets/images/bottom-link_wxgzh.png" />
              <span class="netText">官方服务号</span>
            </li>
            <li class="netLi" @touchstart="showQRCode('wxfwh')">
              <img class="wx" src="../assets/images/bottom-link_wx.png" />
              <span class="netText">微信公众号</span>
            </li>
            <li class="netLi" @touchstart="showQRCode('gdpzh')">
              <img class="wx" src="../assets/images/bottom-link_gdp.png" />
              <span class="netText">逛当铺</span>
            </li>
          </div>
        </div>
        <div class="page8-policy">
          <p style="color: #ffffff">
            ©2005~2022 中典云科（北京）科技有限公司 京ICP备2022029321号 |
          </p>
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011202004047"
            style="
              display: inline-block;
              text-decoration: none;
              line-height: 20px;
            "
          >
            <img src="../assets/images/bottom-baImg.png" style="float: left" />
            <p
              style="
                float: left;
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #ffffff;
              "
            >
              京公网安备 11011202004047号
            </p>
          </a>
        </div>
      </div>
    </div>
    <Overlay
      :show="overlayShow"
      @touchstart.prevent="overlayStart"
      @touchend.prevent="overlayEnd"
      @click="overlayClick"
      class="vanOverlay"
    >
      <div class="wrapper" @click.stop>
        <div v-if="qywxShow" class="imgWrap">
          <img
            class="QRCImg"
            src="../assets/images/bottom-lxkf.png"
            style="border-radius: 20px"
            alt="扫一扫"
          />
          <div class="QRCImgText">长按或截图保存，扫描咨询中典云官方客服</div>
        </div>
        <div v-if="wxfwhShow" class="imgWrap">
          <img
            class="QRCImg"
            src="../assets/images/mobile-QRCode_wxfwh.png"
            alt="扫一扫"
          />
          <div class="QRCImgText">
            长按或截图保存，扫描并关注中典云微信公众号
          </div>
        </div>
        <div v-if="wxgzhShow" class="imgWrap">
          <img
            class="QRCImg"
            src="../assets/images/mobile-QRCode_wxgzh.png"
            alt="扫一扫"
          />
          <div class="QRCImgText">
            长按或截图保存，扫描并关注中典云官方服务号
          </div>
        </div>
        <div v-if="gdpzhShow" class="imgWrap">
          <img
            class="QRCImg"
            src="../assets/images/mobile-QRCode_gdpzh.png"
            alt="扫一扫"
          />
          <div class="QRCImgText">长按或截图保存，扫描进入逛当铺</div>
        </div>
      </div>
    </Overlay>
  </div>
</template>
<script>
import { Tab, Tabs, Overlay } from "vant";
export default {
  name: "index",
  data() {
    return {
      //mobile
      tabActive: "7",
      overlayShow: false,
      qywxShow: false,
      wxfwhShow: false,
      wxgzhShow: false,
      gdpzhShow: false,
      messageFormShow: false,
      mesFoldBtnText: "展开",
      //pc
      btnDisabled: false,
      activeIndex: "0",
      liItemActive: "7",
      itemIndex: "7",
      scrollTop: "",
      messageForm: {
        customerName: "", //姓名
        customerPhone: "", //电话
        customerEmail: "", //邮箱
        customerCompany: "", //公司
        messageContent: "", //留言内容
      },
      ddyShow: false,
      zxptShow: false,
      jgptShow: false,
      stptShow: false,
      isAnimation2: false,
      isAnimation3: false,
      isAnimation4: false,
      isAnimation5: false,
      longTouch: false,
    };
  },
  components: {
    Tab,
    Tabs,
    Overlay,
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      this.onPlayerEnded1();
    });
    //手机端第二页旋转动画
    var container = document.getElementById("container");
    var deg = 0,
      startX,
      endX,
      currentFlag = "Y";
    container.ontouchstart = function (e) {
      startX = e.changedTouches[0].clientX;
    };
    container.ontouchend = function (e) {
      endX = e.changedTouches[0].clientX;
      if (startX < endX) {
        deg = deg + 90;
        container.style.transform = `rotateY(${deg}deg)`;
        currentFlag = "Z";
      } else {
        deg = deg - 90;
        currentFlag = "Y";
        container.style.transform = `rotateY(${deg}deg)`;
      }
      console.log("startX, endX", startX, endX, currentFlag);
      //点击旋转小胶囊中的问题随着变化
      let a = container.getElementsByClassName("a")[0];
      a.ontouchend = function (e) {
        // debugger
        if (currentFlag == "Y") {
          document.getElementsByClassName("bar1")[0].innerHTML = "生态合作伙伴";
        } else if (currentFlag == "Z") {
          document.getElementsByClassName("bar1")[0].innerHTML = "在线平台";
        }
        console.log("ontouchstart===a");
      };
      let b = container.getElementsByClassName("b")[0];
      b.ontouchend = function () {
        if (currentFlag == "Y") {
          document.getElementsByClassName("bar1")[0].innerHTML = "监管接口平台";
        } else {
          document.getElementsByClassName("bar1")[0].innerHTML = "中典云";
        }
        console.log("ontouchstart===b");
      };

      let c = container.getElementsByClassName("c")[0];
      c.ontouchend = function () {
        if (currentFlag == "Y") {
          document.getElementsByClassName("bar1")[0].innerHTML = "在线平台";
        } else {
          document.getElementsByClassName("bar1")[0].innerHTML = "生态合作伙伴";
        }
        console.log("ontouchstart===c");
      };
      let d = container.getElementsByClassName("d")[0];
      d.ontouchend = function () {
        if (currentFlag == "Y") {
          document.getElementsByClassName("bar1")[0].innerHTML = "中典云";
        } else {
          document.getElementsByClassName("bar1")[0].innerHTML = "监管接口平台";
        }
        console.log("ontouchstart===d");
      };
    };

    //移动端微信浏览器中自动播放视屏
    var voice = document.getElementById("videoPlay");
    if (
      typeof WeixinJSBrdgeReady == "object" &&
      typeof WeixinJSBridge.invoke == "function"
    ) {
      voice.play();
    } else {
      if (document.addEventListener) {
        document.addEventListener(
          "WeixinJSBridgeReady",
          function () {
            voice.play();
          },
          false
        );
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", function () {
          voice.play();
        });
        document.attachEvent("onWeixinJSBridgeReady", function () {
          voice.play();
        });
      }
    }
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    //移动事件----start
    unFold() {
      this.messageFormShow = !this.messageFormShow;
      if (this.messageFormShow) {
        this.mesFoldBtnText = "收起";
      } else {
        this.mesFoldBtnText = "展开";
      }
    },

    //点击弹出二维码
    showQRCode(flag) {
      console.log("showQRCode", flag);
      this.overlayShow = true;
      if (flag == "qywx") {
        this.qywxShow = true;
        this.wxfwhShow = false;
        this.wxgzhShow = false;
        this.gdpzhShow = false;
      } else if (flag == "wxfwh") {
        this.qywxShow = false;
        this.wxfwhShow = true;
        this.wxgzhShow = false;
        this.gdpzhShow = false;
      } else if (flag == "wxgzh") {
        this.qywxShow = false;
        this.wxfwhShow = false;
        this.wxgzhShow = true;
        this.gdpzhShow = false;
      } else if (flag == "gdpzh") {
        this.qywxShow = false;
        this.wxfwhShow = false;
        this.wxgzhShow = false;
        this.gdpzhShow = true;
      }
    },
    overlayStart() {
      // 模拟长按
      clearTimeout(this.loop); // 再次清空定时器，防止重复注册定时器（会把点击事件也阻止掉）
      this.longTouch = false; // 关键
      this.loop = setTimeout(() => {
        this.longTouch = true; // 关键
      }, 600);
    },
    overlayEnd() {
      clearTimeout(this.loop); // 清空定时器，防止重复注册定时器
      if (!this.longTouch) {
        //如果不是长按，执行点击事件
        this.overlayShow = false;
      }
    },
    overlayClick(e) {
      console.log("overlayClick", e);
      this.overlayShow = false;
    },
    //移动事件----end
    //保存留言
    saveMessage() {
      this.btnDisabled = true;
      if (!this.messageForm.customerPhone) {
        this.$message({
          message: "您好，请填写您电话方便我们联系您",
          type: "warning",
        });
        this.btnDisabled = false;
        return false;
      }
      if (!this.messageForm.messageContent) {
        this.$message({
          message: "您好，请填写您的留言内容",
          type: "warning",
        });
        this.btnDisabled = false;
        return false;
      }
      this.$http
        .post("/message/add", this.messageForm)
        .then((res) => {
          this.btnDisabled = false;
          this.$refs.messageForm.resetFields();
          this.$message({
            message: "感谢您宝贵的留言，已提交成功",
            type: "success",
          });
          console.log("res======", res);
        })
        .catch((err) => {
          this.btnDisabled = false;
          this.$message({
            message: "请联系管理员",
            type: "error",
          });
          console.log("err======", err);
        });
    },

    handleScroll(e) {
      this.scrollTop = Math.floor(
        document.documentElement.scrollTop || document.body.scrollTop
      );
      // console.log(this.scrollTop);
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(".indexPage .page");
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop);
      });
      // console.log('offsetTopArr', offsetTopArr);
      for (let i = 0; i < offsetTopArr.length; i++) {
        //定位导航
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 i 了
        if (this.scrollTop >= offsetTopArr[i]) {
          this.activeIndex = i;
        }

        //从第二屏开始加入动画
        if (i == 0) {
          if (this.scrollTop >= (offsetTopArr[i + 1] * 1) / 3) {
            this.isAnimation2 = true;
            // console.log('-----动画000---', i, this.scrollTop, offsetTopArr, (offsetTopArr[i + 1] * 4) / 5)
          }
        } else if (i == 1) {
          if (this.scrollTop >= (offsetTopArr[i + 1] * 2) / 3) {
            this.isAnimation3 = true;
            // console.log('-----动画1111---', i, this.scrollTop, offsetTopArr, (offsetTopArr[i + 1] * 4) / 5)
          }
        } else if (i == 2) {
          if (this.scrollTop >= (offsetTopArr[i + 1] * 4) / 5) {
            this.isAnimation4 = true;
            // console.log('-----动画2222---', i, this.scrollTop, offsetTopArr, (offsetTopArr[i + 1] * 2) / 3)
          }
        } else if (i == 3) {
          if (this.scrollTop >= (offsetTopArr[i + 1] * 8) / 9) {
            this.isAnimation5 = true;
            // console.log('-----动画333---', i, this.scrollTop, offsetTopArr, (offsetTopArr[i + 1] * 8) / 9)
          }
        }
      }
    },
    onPlayerEnded1() {
      // console.log('onPlayerEnded1------')
      var bannerVideo1 = this.$refs.bannerVideo1;
      bannerVideo1.play();
    },
    onPlayerEnded2() {
      // console.log('onPlayerEnded2------')
      var bannerVideo2 = this.$refs.bannerVideo2;
      bannerVideo2.play();
    },
    carouselChange(value) {
      if (value == 0) {
        this.onPlayerEnded1();
      } else if (value == 1) {
        this.onPlayerEnded2();
      }
      // console.log('carouselChange', value);
    },
    navClick(index) {
      this.activeIndex = index;
    },
    //saas模块
    liItemClick(index) {
      this.liItemActive = index;
      this.itemIndex = index;
    },
    ddyMouseover() {
      this.ddyShow = true;
    },
    ddyMouseout() {
      this.ddyShow = false;
    },
    zxptMouseover() {
      this.zxptShow = true;
    },
    zxptMouseout() {
      this.zxptShow = false;
    },
    jgptMouseover() {
      this.jgptShow = true;
    },
    jgptMouseout() {
      this.jgptShow = false;
    },
    stptMouseover() {
      this.stptShow = true;
    },
    stptMouseout() {
      this.stptShow = false;
    },
    toTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop, "scrollTop");
      if (scrollTop > 0) {
        const timeTop = setInterval(() => {
          document.documentElement.scrollTop =
            document.body.scrollTop =
            scrollTop -=
              50; //一次减50往上滑动
          if (scrollTop <= 0) {
            clearInterval(timeTop);
          }
        }, 10); //定时调用函数使其更顺滑
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes fadeInUp {
  0% {
    transform: translateY(80px);
    opacity: 0;
  }
}

@keyframes ddyCircle {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.fadeInUp {
  animation: fadeInUp 1.5s;
}

.indexPage {
  position: relative;
  min-width: 13rem;

  .page1 {
    position: relative;

    .activeNav {
      background: #1e3f88;
    }

    .navWrap {
      position: fixed;
      display: flex;
      width: 100%;
      height: 0.72rem;
      justify-content: center;
      z-index: 10;

      .headerNav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 80%;

        .headerLogo {
          width: 2.24rem;
          height: 0.28rem;
        }

        .nav-ul {
          display: flex;
          margin-left: 0.97rem;

          .active {
            height: 0.72rem;
            line-height: 0.72rem;
            background: linear-gradient(
              360deg,
              #5a8dff 0%,
              rgba(90, 141, 255, 0) 100%
            );
          }

          .itemLi {
            height: 0.72rem;
            line-height: 0.72rem;
            text-align: center;
            margin-right: 0.27rem;
            min-width: 0.86rem;
            box-sizing: border-box;
            display: flex;

            a {
              min-width: 0.86rem;
              font-size: 0.15rem;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #ffffff;
            }

            &:hover {
              height: 0.72rem;
              line-height: 0.72rem;
              background: linear-gradient(
                360deg,
                #5a8dff 0%,
                rgba(90, 141, 255, 0) 100%
              );
            }
          }
        }

        .headerTel {
          min-width: 1.6rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .tel-icon {
            display: inline-block;
            background: url(../assets/images/icon-lxwm.png);
            width: 0.18rem;
            height: 0.18rem;
            background-size: 100% 100%;
            margin-right: 0.07rem;
          }

          .tel-num {
            font-size: 0.15rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }

          .itemLi {
            font-size: 0.15rem;
            font-family: Microsoft YaHei;
            font-weight: 400;

            a {
              color: #ffffff;
            }
          }
        }
      }
    }

    .banner1-content {
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .banner1-inner {
        width: 70%;

        .line1 {
          width: 9.63rem;
          height: 0.7rem;
        }

        .line2 {
          font-size: 0.38rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          margin-top: 0.12rem;
          margin-bottom: 0.08rem;
        }

        .line3 {
          font-size: 0.14rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }

        .imgPC {
          display: inline-block;
          width: 0.8rem;
          height: 0.25rem;
          margin-top: 1.21rem;
          margin-bottom: 0.3rem;
        }

        .ljty {
          width: 1.23rem;
          height: 0.38rem;
          background: linear-gradient(180deg, #5a8dff 0%, #1e3f88 100%);
          border-radius: 6px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 38px;
          margin-left: -6px;
          text-align: center;
        }

        animation: fadeInUp 2s;
      }
    }

    .banner2-content {
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .banner2-inner {
        width: 70%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .banner2-logo {
          display: inline-block;
          width: 4.14rem;
          height: 0.52rem;
        }

        .banner2-line {
          width: 0.34rem;
          height: 0.02rem;
          background: #ffffff;
          margin-top: 0.4rem;
          margin-bottom: 0.5rem;
        }

        .banner2-text-wrap {
          text-align: center;

          .banner2-text {
            font-size: 0.16rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 0.3rem;
            color: rgba(255, 255, 255, 0.8);
          }
        }

        animation: fadeInUp 2s;
      }
    }

    .pageDownarrow {
      display: inline-block;
      height: 0.38rem;
      width: 100%;
      position: absolute;
      bottom: -0.26rem;
      z-index: 2;
    }
  }

  .page2 {
    margin-top: -0.38rem;

    background: linear-gradient(180deg, #00122e 0%, #18336e 100%);
    display: flex;
    justify-content: center;

    .page2-inner {
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 1.4rem;
      padding-bottom: 1.8rem;

      // animation: fadeInUp 2s;

      .line1 {
        font-size: 0.3rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }

      .line2 {
        font-size: 0.1rem;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #ffffff;
        margin-top: 0.15rem;
        margin-bottom: 0.35rem;
      }

      .center {
        position: relative;

        .ddybox {
          position: relative;

          .ddy {
            display: inline-block;
            width: 5.2rem;
            height: 5.2rem;
            z-index: 1;
            animation: ddyCircle 5s linear infinite;
          }

          .ddyLogo {
            display: inline-block;
            width: 2rem;
            height: 1rem;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .commonboxShow {
          width: 232px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #5a8dff;
          box-shadow: 0 0 0.2rem #5a8dff inset;

          transition-property: height;
          transition-duration: 5s;
          transition-timing-function: ease-out;
          transition-delay: 5s;

          .title {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
          }

          .text {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #ffffff;
          }
        }

        .ddh {
          display: inline-block;
          width: 3.75rem;
          height: 0.62rem;
          position: absolute;
          left: -3.14rem;
          top: 0.08rem;
        }

        .mouseBox {
          &:hover {
            cursor: pointer;
          }
        }

        .commonboxHide {
          width: 232px;
          padding-top: 42px;
          padding-bottom: 30px;
          display: flex;
          flex-direction: column;
          text-align: center;
          background: linear-gradient(
            180deg,
            rgba(90, 141, 255, 0) 0%,
            rgba(90, 141, 255, 0.8) 100%
          );
          border: 1px solid #5a8dff;
          box-shadow: 0 0 0.2rem #5a8dff inset;

          .title {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            margin-bottom: 14px;
          }

          .text {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #ffffff;
            line-height: 24px;
          }
        }

        .ddyAbso {
          position: absolute;
          left: -3.14rem;
          top: 0.28rem;
        }

        .hyxh {
          display: inline-block;
          width: 3.21rem;
          height: 0.47rem;
          position: absolute;
          left: -3.14rem;
          bottom: 0.96rem;
        }

        .zxptAbso {
          position: absolute;
          left: -3.14rem;
          bottom: 1.16rem;
        }

        .jgbm {
          display: inline-block;
          width: 3.75rem;
          height: 0.62rem;
          position: absolute;
          left: 4.66rem;
          top: 0.07rem;
        }

        .jgptAbso {
          position: absolute;
          right: -3.21rem;
          top: 0.27rem;
        }

        .pgjg {
          display: inline-block;
          width: 3.21rem;
          height: 0.47rem;
          position: absolute;
          left: 5.2rem;
          bottom: 0.96rem;
        }

        .stptAbso {
          position: absolute;
          right: -3.21rem;
          bottom: 1.16rem;
        }

        .jrkj {
          display: inline-block;
          width: 3.82rem;
          height: 0.68rem;
          position: absolute;
          bottom: 0.3rem;
          left: 0.7rem;
          z-index: 3;
        }

        .bottomPlate {
          left: -315px;
          bottom: -64px;
          position: absolute;
          z-index: 2;
          width: 1160px;
          height: 104px;
          background: #132c61;
          border: 1px solid #5a8dff;
          box-shadow: 0 0 0.2rem #5a8dff inset;
          display: flex;
          align-items: center;
          justify-content: space-around;

          .plateLi {
            padding-bottom: 14px;
            padding-top: 14px;
            padding-left: 47px;
            padding-right: 47px;
            border: 1px solid rgba(90, 141, 255, 0.4);

            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;

            &:hover {
              cursor: pointer;
              background: linear-gradient(
                360deg,
                rgba(90, 141, 255, 0.8) 0%,
                rgba(90, 141, 255, 0.3) 100%
              );
            }
          }
        }
      }
    }
  }

  .page3-bg {
    // background: url(../assets/images/page3-bg.png);
    background: url("https://pic.imgdb.cn/item/63f70c05f144a01007227a02.png");
    background-size: 100% 100%;
    width: 100%;
    height: 890px;
  }

  .page3 {
    background: linear-gradient(180deg, #18336e 0%, #3054af 100%);
    display: flex;
    justify-content: center;

    .page3-inner {
      padding-top: 1.12rem;
      position: absolute;
      width: 70%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      // animation: fadeInUp 2s;

      .inner-up {
        display: flex;
        flex-direction: column;
        align-items: center;

        .page3-ddlogo {
          width: 120px;
          height: 15px;
        }

        .page3-title {
          margin-top: 30px;
          margin-bottom: 15px;
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
        }

        .page3-subtitle {
          margin-bottom: 30px;
          font-size: 10px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #ffffff;
        }

        .page3-btn-pc {
          width: 286px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border: 1px solid #5a8dff;
          border-radius: 6px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .inner-middle {
        display: flex;
        margin-top: 51px;
        width: 100%;
        justify-content: space-between;

        .liItem {
          display: flex;
          box-sizing: border-box;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 124px;
          height: 124px;
          border: 1px solid transparent;

          .icon {
            display: inline-block;
            width: 40px;
            height: 40px;
            color: #ffffff;
            opacity: 0.5;
            font-size: 36px;
          }

          .icon-text {
            margin-top: 21px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            opacity: 0.7;
          }

          &:hover {
            cursor: pointer;
            width: 124px;
            height: 124px;
            color: #ffffff;
            opacity: 1;
            border: 1px solid #5a8dff;
            border-radius: 6px;
            background: linear-gradient(
              180deg,
              #4770c9 0%,
              rgba(90, 141, 255, 0.1) 100%
            );

            .icon {
              display: inline-block;
              width: 40px;
              height: 40px;
              color: #ffffff;
              opacity: 1;
              font-size: 36px;
            }

            .icon-text {
              margin-top: 21px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              opacity: 1;
            }
          }
        }

        .liItemActive {
          width: 124px;
          height: 124px;
          color: #ffffff;
          opacity: 1;
          border: 1px solid #5a8dff;
          border-radius: 6px;
          background: linear-gradient(
            180deg,
            #4770c9 0%,
            rgba(90, 141, 255, 0.1) 100%
          );

          .icon {
            display: inline-block;
            width: 40px;
            height: 40px;
            color: #ffffff;
            opacity: 1;
            font-size: 36px;
          }

          .icon-text {
            margin-top: 21px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            opacity: 1;
          }
        }
      }

      .inner-bottom {
        margin-top: 42px;
        width: 100%;

        .itemShow {
          display: block;
        }

        .itemHidden {
          display: none !important;
        }

        .bottom-item {
          border: 1px solid #5a8dff;
          border-radius: 6px;
          overflow: hidden;
          background: linear-gradient(
            180deg,
            rgba(90, 141, 255, 0.8) 0%,
            rgba(90, 141, 255, 0.1) 100%
          );
          display: flex;
          align-items: center;
          justify-content: space-between;

          .bottom-right {
            display: flex;
            flex-direction: column;
            margin-left: 61px;

            .right-line1 {
              font-size: 30px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #ffffff;
            }

            .right-line2 {
              margin-top: 6px;
              margin-bottom: 6px;
              font-size: 30px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              letter-spacing: 2px;
            }

            .right-line3 {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              color: #ffffff;
              margin-bottom: 32px;
            }

            .right-btn {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 146px;
              height: 38px;
              border: 1px solid #ffffff;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #ffffff;
              border-radius: 6px;
            }
          }

          .bottom-left {
            .page3-img {
              width: 473px;
              height: 315px;
            }
          }
        }
      }
    }
  }

  .page4 {
    display: flex;
    justify-content: center;

    .page4-bg {
      // background: url(../assets/images/page4-bg.png);
      background-size: 100% 100%;
      width: 100%;
      margin-top: -1.9rem;
      height: 10.07rem;
    }

    .page4-inner {
      position: absolute;
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 1.44rem;

      // animation: fadeInUp 2s;

      .inner-up {
        display: flex;
        flex-direction: column;
        align-items: center;

        .page4-title {
          font-size: 0.3rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #303030;
        }

        .page4-subtitle {
          margin-top: 0.15rem;
          margin-bottom: 0.3rem;
          font-size: 0.1px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #000000;
        }

        .page4-btn-mobile {
          width: 286px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border: 1px solid #5a8dff;
          border-radius: 6px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #4770c9;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .inner-bottom {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: 81px;

        .bottom-card {
          width: 335px;
          height: 335px;
          background: #ffffff;
          box-shadow: 0px 10px 10px #efefef;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            cursor: pointer;
            background: linear-gradient(180deg, #4a7ae0 0%, #1e3f88 100%);
            transform: scale(1.2, 1.2);

            .card-innner {
              display: flex;
              flex-direction: column;
              align-items: center;

              .card-title {
                display: flex;
                align-items: center;
                margin-bottom: 53px;

                .icon {
                  width: 48px;
                  height: 48px;
                  font-size: 40px;
                  color: #ffffff;
                  display: flex;
                  align-items: center;
                }

                .title-text {
                  font-size: 20px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #ffffff;
                  margin-left: 18px;
                }
              }

              .card-content {
                .liItem {
                  font-size: 15px;
                  font-family: Microsoft YaHei;
                  font-weight: 300;
                  color: #ffffff;
                  line-height: 26px;

                  .dot {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                    margin-right: 20px;
                  }
                }
              }
            }
          }

          .card-innner {
            display: flex;
            flex-direction: column;
            align-items: center;

            .card-title {
              display: flex;
              align-items: center;
              margin-bottom: 53px;

              .icon {
                width: 40px;
                height: 40px;
                font-size: 40px;
                color: #4770c9;
                display: flex;
                align-items: center;
              }

              .title-text {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                margin-left: 18px;
              }
            }

            .card-content {
              .liItem {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 300;
                color: #000000;
                line-height: 26px;

                .dot {
                  display: inline-block;
                  width: 8px;
                  height: 8px;
                  border: 1px solid #000000;
                  border-radius: 50%;
                  margin-right: 20px;
                }
              }
            }
          }
        }
      }
    }
  }

  .page5 {
    background: linear-gradient(180deg, #01275a 0%, #3457b2 100%);
    display: flex;
    justify-content: center;
    padding-top: 80px;
    padding-bottom: 80px;

    .page5-inner {
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      // animation: fadeInUp 2s;

      .page5-title {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }

      .page5-subtitle {
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #ffffff;
        margin-top: 15px;
        margin-bottom: 38px;
      }

      .page5-img {
        width: 1160px;
        height: 553px;
      }
    }
  }

  .page6 {
    display: flex;
    justify-content: center;
    margin-top: -1px;

    .page6-bg {
      // background: url(../assets/images/page6-bg.png);
      background: url("https://pic.imgdb.cn/item/63f70c17f144a010072296d1.png");
      background-size: 100% 100%;
      width: 100%;
      height: 900px;
    }

    .page6-inner {
      margin-top: 100px;
      position: absolute;
      width: 70%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      // animation: fadeInUp 2s;

      .page6-title {
        font-size: 0.3rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }

      .page6-subtitle {
        font-size: 0.1rem;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #ffffff;
        margin-top: 0.15rem;
        margin-bottom: 0.84rem;
      }

      .page6-item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.6rem;

        .itemLi {
          display: flex;

          .itemImg {
            width: 0.62rem;
            height: 0.62rem;
            margin-right: 0.14rem;
          }

          .itemRight {
            display: flex;
            flex-direction: column;

            .rightTitle {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              margin-bottom: 5px;
            }

            .rightContent {
              font-size: 9px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              color: #ffffff;
            }
          }
        }
      }

      .page6-content {
        margin-top: 60px;
        margin-bottom: 50px;
        width: 100%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 1px;
        min-width: 1160px;

        p {
          line-height: 30px;
        }
      }

      .page6-panel {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        min-width: 1160px;
        height: 220px;
        background: #ffffff;
        border-radius: 10px;

        .itemLi {
          display: flex;
          flex-direction: column;
          align-items: center;

          .itemImg {
            width: 40px;
            height: 40px;
          }

          .imgTitle {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #a3a3a3;
            margin-top: 20px;
            margin-bottom: 30px;
          }

          .itemTitle {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #303030;
          }
        }
      }
    }
  }

  .page7 {
    background: #ffffff;
    display: flex;
    justify-content: center;
    padding-top: 125px;
    padding-bottom: 125px;

    .page7-inner {
      width: 70%;
      // animation: fadeInUp 2s;

      .page7-title {
        .title {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #303030;
        }

        .subTitle {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #a3a3a3;
          margin-top: 5px;
          margin-bottom: 49px;
        }
      }

      .page7-form {
        .formRow {
          display: flex;

          .mr32 {
            margin-right: 32px;
          }

          .formItem {
            width: 50%;
            height: 55px;
            background: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: 20px;
          }

          .formItem1 {
            width: 100%;
            height: 210px;
            background: #f5f5f5;
            display: flex;
            align-items: flex-start;
            padding-left: 20px;
          }
        }

        .messageBtn {
          width: 100%;
          background: #01275a;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }

  .page8 {
    width: 100%;
    height: 3.2rem;
    background: linear-gradient(360deg, #00122e 0%, #01275a 100%);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .page8-outer {
      display: flex;
      flex-direction: column;
      width: 80%;

      .page8-inner {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .flex {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 0.4rem;
        }

        .flex1 {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: -1rem;
          margin-right: 1rem;
        }

        .bottom-item {
          font-size: 0;

          .bottom-logo {
            // width: 3rem;
            height: 0.38rem;
            margin-bottom: 25px;
          }

          .logo-title {
            font-size: 0.15rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }

          .mt {
            margin-bottom: 0 !important;
          }

          .item {
            margin-bottom: 25px;
            font-size: 0.15rem;

            .label {
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.64);
            }

            .value {
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #ffffff;
            }
          }

          .bottom-QRCode {
            width: 1.05rem;
            height: 1.05rem;
            margin-bottom: 0.08rem;
          }

          .QRCode-title {
            font-size: 0.15rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.64);
          }
        }
      }

      .page8-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 0.13rem;

        .page8-police {
          display: flex;
          // color: rgb(147, 147, 147);
          width: 90%;
          font-size: 0.15rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          .hrefHover {
            &:hover {
              color: #5a8dff !important;
            }
          }
        }

        .backTop {
          cursor: pointer;
          width: 0.78rem;
          height: 0.2rem;
          margin-right: 12px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
// //当屏幕宽度 最小为768px 最大为991px时
@keyframes ddyCircle {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes bounce {
  from,
  to {
    bottom: -15px;
  }

  50% {
    bottom: 0;
  }
}

@media screen and (max-width: 570px) {
  body {
    .indexPage {
      min-width: 320px !important;
    }

    .page1 {
      .page1-inner {
        display: none !important;
      }

      .page1-mobile {
        position: relative;
        height: 700px;

        .mobile1-inner {
          .videoMobile {
            width: 100%;
            min-width: 375px;
            height: 700px;
            object-fit: cover;
          }

          .videoContent {
            position: absolute;
            width: 100%;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            align-items: flex-start;
            justify-content: center;

            .videoContentInner {
              display: flex;
              flex-direction: column;
              width: 100%;
              padding: 0 20px;

              .headerLogoMobile {
                margin-top: 42px;
                width: 160px;
                height: 20px;
              }
              .linkTel {
                display: flex;
                justify-content: space-between;
                padding-top: 20px;
                .headerTel {
                  font-size: 0.15rem;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  display: flex;
                  // min-width: 1.6rem;
                  // margin-top: 42px;
                  align-items: center;
                  align-content: center;
                  margin-left: 0.2rem;
                  .tel-icon {
                    background-image: url(../assets/images/tel-icon.png);
                    background-size: 100% 100%;
                    width: 0.18rem;
                    height: 0.18rem;
                    margin-right: 0.08rem;
                  }
                  a {
                    color: #fff;
                  }
                }
              }
              .line1 {
                width: 325px;
                height: 59px;
                margin-top: 98px;
                margin-bottom: 38px;
              }

              .line2 {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #ffffff;
              }

              .line3 {
                margin-top: 9px;
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                opacity: 0.5;
              }

              .slid {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 203px;
                position: relative;

                .sliding {
                  font-size: 12px;
                  font-family: PingFang SC;
                  font-weight: bold;
                  color: #ffffff;
                  margin-bottom: 12px;
                }

                .openLine {
                  position: absolute;
                  bottom: 0;
                  width: 40px;
                  height: 0px;
                  border: 1px solid #ffffff;
                  animation-name: bounce;
                  animation-iteration-count: infinite;
                  animation-duration: 1.8s;
                }
              }
            }
          }
        }

        .pageDownarrow {
          width: 3.75rem;
          height: 0.2rem !important;
          position: absolute;
          bottom: -14px !important;
        }
      }
    }

    .page2 {
      .page2-inner {
        display: none !important;
      }

      .page2-mobile {
        margin-top: 65px;
        width: 100%;

        .mobile2-inner {
          display: flex;
          flex-direction: column;
          align-items: center;

          .line1 {
            margin-top: 21px;
            margin-bottom: 5px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #ffffff;
          }

          .line2 {
            margin-bottom: 20px;
            font-size: 11px;
            font-family: PingFang SC;
            font-weight: 300;
            color: #ffffff;
            opacity: 0.5;
          }

          .main {
            width: 100%;
            height: 157px;
            margin: 0 auto;

            position: relative;
            bottom: 15px;
            display: flex;
            justify-content: center;

            perspective: 800px;
          }

          .swipWrap {
            // font-size: 0;
            // display: flex;
            transform-style: preserve-3d;
            transition: transform 1s;
            width: 235px;
            height: 140px;

            position: relative;

            .inner {
              width: 177px;
              height: 118px;
              font-size: 12px;

              position: absolute;
              bottom: 0;
            }

            .swipItem {
              border: 1px solid #5a8dff;
              background: linear-gradient(
                180deg,
                rgba(90, 141, 255, 0) 0%,
                rgba(90, 141, 255, 0.8) 100%
              );

              .itemTop {
                position: absolute;
                top: 0;
                width: 100%;
                height: 6px;
                background: linear-gradient(
                  90deg,
                  rgba(90, 141, 255, 0) 0%,
                  #5a8dff 50%,
                  rgba(30, 63, 136, 0) 100%
                );
              }

              .itemContent {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                height: 118px;
                box-shadow: 0 0 20px #5a8dff inset;

                div {
                  line-height: 10px;
                  font-size: 12px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #ffffff;
                  margin-bottom: 8px;
                  transform: scale(0.8, 0.8); //小字体
                }
              }
            }

            .itemwrap {
              width: 177px;
              height: 118px;
              // border: 1px solid #5A8DFF;
              background: linear-gradient(
                180deg,
                rgba(90, 141, 255, 0) 0%,
                rgba(90, 141, 255, 0.8) 100%
              );
            }

            .inner:nth-child(1) {
              transform: rotateY(0deg) translateX(28px) translateY(8px)
                translateZ(200px);
              background: linear-gradient(180deg, #00122e 0%, #18336e 100%);
            }

            .inner:nth-child(2) {
              transform: rotateY(90deg) translateX(0px) translateY(8px)
                translateZ(200px);
              background: linear-gradient(180deg, #00122e 0%, #18336e 100%);
            }

            .inner:nth-child(3) {
              transform: rotateY(180deg) translateX(-29px) translateY(8px)
                translateZ(200px);
              background: linear-gradient(180deg, #00122e 0%, #18336e 100%);
            }

            .inner:nth-child(4) {
              transform: rotateY(270deg) translateX(0px) translateY(8px)
                translateZ(164px);
              background: linear-gradient(180deg, #00122e 0%, #18336e 100%);
            }

            .swip {
              width: 1292px;
              font-size: 0;
              display: flex;
              margin-left: -29px;

              .swipItem {
                width: 235px;
                position: relative;

                margin-right: 39px;

                .itemTop {
                  position: absolute;
                  top: 0;
                  width: 100%;
                  height: 6px;
                  background: linear-gradient(
                    90deg,
                    rgba(90, 141, 255, 0) 0%,
                    #5a8dff 50%,
                    rgba(30, 63, 136, 0) 100%
                  );
                }

                .itemContent {
                  width: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;
                  // height: 157px;

                  margin-right: 39px;

                  div {
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    margin-bottom: 8px;
                  }
                }
              }
            }
          }

          .ddybox {
            position: relative;
            margin-top: 28px;

            .ddy {
              width: 221px;
              height: 221px;
              z-index: 1;
              animation: ddyCircle 5s linear infinite;
            }

            .ddyLogo {
              width: 100px;
              height: 50px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }

            .jrkj {
              width: 235px;
              height: 42px;
              position: absolute;
              bottom: 9px;
              left: -7px;
              z-index: 3;
            }

            .bottomPlate {
              bottom: -38px;
              left: -59px;
              position: absolute;
              z-index: 2;
              width: 335px;
              height: 56px;
              background: #132c61;
              border: 1px solid #5a8dff;
              box-shadow: 0 0 0.2rem #5a8dff inset;
              display: flex;
              align-items: center;
              justify-content: space-around;

              .plateLi {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #ffffff;
              }
            }

            .bar {
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 4;
              background: #1e3f88;
              border: 1px solid #5a8dff;

              box-sizing: border-box;
              box-shadow: 0 0 3px #5a8dff inset;

              span {
                font-family: PingFang SC;
                color: #ffffff;
                font-weight: bold;
                opacity: 0.6;
              }
            }

            .ddybar {
              position: absolute;
              top: -51px;
              left: 25px;
              font-size: 14px;
              font-weight: bold;
              // padding: 9px 51px 9px 52px;
              border-radius: 19px;
              background: #1e3f88;
              border: 1px solid #5a8dff;
              width: 175px;
              height: 38px;

              &:after {
                content: "";
                background: url(../assets/images/page2-trangle.png);
                width: 16px;
                height: 6px;
                position: absolute;
                bottom: 0;
                background-size: 100% 100%;
              }
            }

            .ddypls {
              position: absolute;
              top: 15px;
              left: -60px;
              font-size: 10px;
              transform: scale(0.83, 0.83); //小字体
              padding: 6px 18px 6px 18px;
              letter-spacing: 1px;
              border-radius: 26px;
            }

            .zxpt {
              position: absolute;
              top: 90px;
              left: -75px;
              font-size: 8px;
              transform: scale(0.67, 0.67);
              padding: 5px 23px 5px 23px;
              border-radius: 16px;
            }

            .jgpt {
              position: absolute;
              top: 24px;
              right: -69px;
              font-size: 10px;
              transform: scale(0.83, 0.83);
              padding: 6px 14px 6px 15px;
              border-radius: 26px;
            }

            .stpt {
              position: absolute;
              top: 88px;
              right: -81px;
              font-size: 8px;
              transform: scale(0.67, 0.67);
              padding: 5px 12px 5px 12px;
              border-radius: 16px;
            }
          }
        }
      }
    }

    .page3 {
      position: relative;

      .page3-bg {
        display: none !important;
      }

      .page3-inner {
        display: none !important;
      }

      .page3-bg-mobile {
        background: url(../assets/images/page3-bg-mobile.png);
        background-size: 100% 100%;
        width: 100%;
        height: 280px;
        position: absolute;
        bottom: 0;
      }

      .page3-mobile {
        margin-top: 108px;
        padding-bottom: 35px;
        width: 100%;
        z-index: 3;

        .mobile3-inner {
          .inner-up {
            text-align: center;

            .page3-title {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ffffff;
            }

            .page3-subtitle {
              font-size: 11px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #ffffff;
              opacity: 0.5;
              margin-top: 5px;
              margin-bottom: 20px;
            }
          }

          .inner-bottom {
            padding-right: 20px;
            padding-left: 20px;
            width: 100%;
            box-sizing: border-box;

            .van-tabs__wrap {
              width: 100%;
              overflow-x: scroll;
              touch-action: manipulation;

              .van-tabs__nav {
                display: flex !important;

                .van-tab.van-tab--active {
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  margin-right: 25px;

                  .van-tab__text {
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #ffffff;
                    opacity: 1;
                    padding-bottom: 5px;
                    border-bottom: 2px solid #ffffff;
                    display: inline-block;
                    min-width: 58px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                  }
                }

                .van-tab {
                  font-size: 14px;
                  margin-right: 25px;

                  .van-tab__text {
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    opacity: 0.5;
                    display: inline-block;
                    min-width: 58px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                  }
                }
              }
            }

            .van-tabs__content {
              font-size: 14px;
              // margin-top: 5px;

              .tabContent {
                width: 100%;

                .page3-img-mobile {
                  width: 100%;
                  // height: 185px;
                }

                .content {
                  width: 100%;
                  padding-top: 24px;
                  padding-bottom: 22px;
                  padding-left: 20px;
                  padding-right: 20px;
                  box-sizing: border-box;
                  border: 1px solid #5a8dff;
                  background: linear-gradient(
                    180deg,
                    #5a8dff 0%,
                    rgba(90, 141, 255, 0) 100%
                  );

                  .right-line1 {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #ffffff;
                  }

                  .right-line2 {
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    margin-top: 5px;
                    margin-bottom: 15px;
                  }

                  .right-line3 {
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 300;
                    color: #ffffff;
                    text-align: justify;
                  }
                }
              }
            }
          }
        }
      }
    }

    .page6 {
      position: relative;

      .page6-bg {
        display: none !important;
      }

      .page6-inner {
        display: none !important;
      }

      .page6-mobile-wrap {
        width: 100%;

        .page6-bg-mobile {
          background: url(../assets/images/page6-bg-mobile.png);
          background-size: 100% 100%;
          width: 100%;
          height: 434px;
        }

        .page6-mobile {
          padding-top: 35px;
          padding-bottom: 35px;
          position: absolute;
          bottom: 0;
          left: 0;
          top: 0;
          right: 0;

          .mobile6-inner {
            text-align: center;

            .page6-title {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ffffff;
            }

            .page6-subtitle {
              font-size: 11px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #ffffff;
              margin-top: 5px;
              margin-bottom: 20px;
            }

            .page6-item {
              padding-left: 20px;
              padding-right: 20px;
              padding-bottom: 30px;

              .libg1 {
                background: linear-gradient(
                  270deg,
                  rgba(90, 141, 255, 0.8) 0%,
                  rgba(90, 141, 255, 0) 100%
                );
              }

              .libg2 {
                background: linear-gradient(
                  90deg,
                  rgba(90, 141, 255, 0.8) 0%,
                  rgba(90, 141, 255, 0) 100%
                );
              }

              .itemLi {
                display: flex;
                justify-content: space-around;
                align-items: center;
                margin-bottom: 14px;
                padding-top: 15px;
                padding-bottom: 15px;

                .itemImg {
                  width: 71px;
                  height: 71px;
                }

                .bl {
                  border-left: 1px solid #5a8dff;
                }

                .br {
                  border-right: 1px solid #5a8dff;
                }

                .imgBox {
                  width: 30%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }

                .itemRight {
                  padding-right: 15px;
                  padding-left: 20px;
                  width: 70%;

                  .rightTitle {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #ffffff;
                    margin-bottom: 4px;
                  }

                  .rightContent {
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 300;
                    color: #ffffff;
                    letter-spacing: 1px;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
        }

        .about {
          padding-bottom: 35px;
          background: linear-gradient(180deg, #041e67 0%, #001534 100%);
          text-align: center;

          .aboutUs {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #ffffff;
            margin-top: -26px;
            margin-bottom: 24px;
            padding-top: 110px;
            opacity: 0.5;
          }

          .page6-content {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 300;
            color: #ffffff;
            margin-bottom: 30px;
            line-height: 22px;
            letter-spacing: 1px;
            opacity: 0.5;
          }

          .page6-panel {
            display: flex;
            justify-content: space-around;
            margin-top: 30px;

            .itemLi {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;

              .itemImg {
                width: 20px;
                height: 20px;
              }

              .imgTitle {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #ffffff;
                margin-top: 8px;
                margin-bottom: 6px;
              }

              .itemTitle {
                font-size: 10px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #ffffff;
                transform: scale(0.83, 0.83);
                opacity: 0.5;
              }
            }
          }
        }
      }
    }

    .page7 {
      display: none !important;
    }

    .page7-mobile {
      width: 100%;

      .mobile-inner {
        padding-top: 35px;
        padding-bottom: 35px;
        padding-left: 20px;
        padding-right: 20px;

        .page7-title {
          display: flex;
          justify-content: space-between;

          .messageTitle {
            .title {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #00122e;
            }

            .subTitle {
              font-size: 11px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #00122e;
              opacity: 0.5;
            }
          }

          .unfoldBtn {
            width: 80px;
            height: 30px;
            background: #01275a;
            font-size: 12px;
            font-family: PingFang SC;
            color: #ffffff;
            text-align: center;
            line-height: 30px;
            cursor: pointer;
          }
        }

        .page7-form {
          margin-top: 33px;

          .el-form-item {
            margin-bottom: 10px;
          }

          .formItem {
            height: 50px;
            background: #f5f5f5;
            display: flex;
            align-items: center;

            .el-form-item__label {
              font-size: 14px !important;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #303030;
              margin-left: 25px;
            }
          }

          .formItem1 {
            width: 100%;
            height: 120px;
            background: #f5f5f5;
            display: flex;
            align-items: flex-start;
            flex-direction: column;

            .el-form-item__label {
              font-size: 14px !important;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #303030;
              margin-top: 5px;
              margin-left: 25px;
            }
          }

          .messageBtn {
            width: 100%;
            background: #01275a;
            font-size: 13px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            height: 47px;
          }

          .el-form-item__content {
            width: 100% !important;
            margin-left: 0 !important;

            .el-input--mini {
              .el-input__inner {
                border: none;
                background: #f5f5f5;
                font-size: 0.14rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #a3a3a3;
                // vertical-align: -2px;
                padding-left: 0;
              }
            }

            .el-textarea {
              .el-textarea__inner {
                border: none;
                height: 60px;
                background: #f5f5f5;
                font-size: 0.14rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #a3a3a3;
                padding-left: 25px;
                padding-top: 2px;
              }
            }
          }
        }
      }
    }

    .page8 {
      display: none !important;
    }

    .page8-mobile {
      padding-top: 35px;
      background: linear-gradient(360deg, #00122e 0%, #01275a 100%);
      text-align: left;

      .page8-mobile-inner {
        padding-left: 20px;
        padding-bottom: 30px;
        letter-spacing: 1px;

        .bottom-item {
          font-size: 11px;

          .bottom-logo {
            width: 160px;
            height: 20px;
          }

          .logo-title {
            font-size: 11px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
            margin-top: 10px;
            margin-bottom: 25px;
          }
        }

        .bottom-link {
          .icon {
            display: inline-block;
            width: 13px;
            height: 13px;
            margin-right: 8px;
          }

          .linkLi {
            margin-bottom: 14px;
            display: flex;

            .zxrx {
              background: url("../assets/images/bottom-link-zxrx.png");
              background-size: 100% 100%;
            }

            .qyyx {
              background: url("../assets/images/bottom-link-qyyx.png");
              background-size: 100% 100%;
            }

            .label {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.64);
              display: flex;
              align-items: center;
            }

            .value {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ffffff;
            }
          }
        }

        .bottom-linknet {
          display: flex;
          flex-wrap: wrap;

          .netLi {
            display: flex;
            align-items: center;
            margin-right: 30px;
            margin-top: 20px;

            &:hover {
              cursor: pointer;
            }

            .wx {
              width: 16px;
              height: 16px;
              margin-right: 6px;
            }

            .netText {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }
          }
        }
      }

      .page8-policy {
        border-top: 1px solid rgba(255, 255, 255, 0.1529);
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: 300;
        color: #ffffff !important;
        padding-top: 30px;
        padding-bottom: 30px;
        text-align: center;

        div {
          letter-spacing: 1px;
          line-height: 21px;
        }
      }
    }
  }
}

//当屏幕最小宽度为570px  >=570
@media (min-width: 570px) {
  body {
    .page1-mobile {
      display: none;
    }

    .page2-mobile {
      display: none;
    }

    .page3-bg-mobile {
      display: none;
    }

    .page3-mobile {
      display: none;
    }

    .page6-bg-mobile {
      display: none;
    }

    .page6-mobile {
      display: none;
    }

    .about {
      display: none;
    }

    .page7-mobile {
      display: none;
    }

    .page8-mobile {
      display: none;
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
div::-webkit-scrollbar {
  width: 0;
}

// 移动端二维码样式
.vanOverlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: rgba(16, 16, 16, 0.6);

    .imgWrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .QRCImg {
        width: 295px;
        height: 295px;
      }

      .QRCImgText {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin-top: 16px;
        text-align: center;
      }
    }
  }
}

// 1rem = 100px
.video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

video::-webkit-media-controls-start-playback-button {
  display: none;
}

video {
  pointer-events: none;
}

.el-carousel__item.is-animating {
  transition: opacity 0.8s ease-in-out !important;
}

.el-carousel {
  width: 100%;
  height: 100vh;
  min-width: 13rem;
}

.el-carousel__container {
  width: 100%;
  height: 100vh !important;
  position: relative;
}

.el-carousel__button {
  width: 0.6rem;
}

.el-carousel__indicators {
  margin-bottom: 0.46rem;
}

.formItem,
.formItem1 {
  .el-form-item__label {
    font-size: 16px !important;
    font-family: Microsoft YaHei !important;
    font-weight: 400 !important;
    color: #303030 !important;
  }
}

.pc.formItem1 {
  .el-form-item__label {
    font-size: 16px !important;
    font-family: Microsoft YaHei !important;
    font-weight: 400 !important;
    color: #303030 !important;
    margin-top: 7px;
  }
}

.pc {
  .el-form-item__content {
    width: 100% !important;
    margin-left: 0 !important;

    .el-input--mini {
      .el-input__inner {
        border: none;
        background: #f5f5f5;
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #a3a3a3;
        margin-left: -38px;
        vertical-align: -2px;
      }
    }

    .el-textarea {
      .el-textarea__inner {
        border: none;
        height: 150px;
        background: #f5f5f5;
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #a3a3a3;
        margin-top: 40px;
        margin-left: -97px;
      }
    }
  }
}

// 移动端输入框
.el-form-item__content {
  width: 100% !important;
  margin-left: 0 !important;

  .el-input--mini {
    .el-input__inner {
      border: none;
      background: #f5f5f5;
      font-size: 0.14rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #a3a3a3;
    }
  }

  .el-textarea {
    .el-textarea__inner {
      border: none;
      // height: 2rem;
      background: #f5f5f5;
      font-size: 0.14rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #a3a3a3;
      padding-top: 0.1rem;
      // margin-left: -0.05rem;
    }
  }
}
</style>
